<template>
  <v-container>
    <div>
      <v-row justify="space-between">
        <v-col cols="12" sm="5" justify="center">
          <p class="header-title"> {{ $t('target.target_management') }} </p>
        </v-col>

        <v-col cols="12" sm="7">
          <div class="d-flex flex-row-reverse">
            <v-btn color="primary" dark @click="showCreateTargetDialog">{{ $t('common.create') }}</v-btn>

            <v-btn color="primary" dark @click="getData" class="mr-5">{{ $t('common.refresh') }}</v-btn>
          </div>
        </v-col>
      </v-row>
    </div>
    <v-data-table :headers="headers" :items="desserts" :search="search" class="elevation-1" hide-default-footer
                  :page.sync="page" :loading="loading" :items-per-page="itemsPerPage" @page-count="pageCount = $event">
      <template v-slot:top>
        <v-toolbar flat color="white" class="pt-5">
          <v-row justify="start">
            <v-col cols="12" sm="1">
              <v-autocomplete v-model="itemsPerPage" :items="numberPage" outlined :dense="true"></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="2">
              <v-autocomplete v-model="selectProvince" :items="provinces" item-text="province_name"
                              v-bind:label="$t('location_assign.select_province')" return-object outlined
                              dense></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="2">
              <v-autocomplete v-model="selectDistrict" :items="districts" item-text="district_name"
                              v-bind:label="$t('location_assign.select_district')" return-object outlined
                              :dense="true"></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="2">
              <v-autocomplete v-model="selectOrderUnit" :items="orderUnits" item-text="name"
                              v-bind:label="$t('location_assign.order_unit')" return-object outlined
                              :dense="true"></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="2">
              <v-autocomplete v-model="selectOption" :items="options" item-text="title"
                              v-bind:label="$t('order_unit.option')" return-object outlined
                              :dense="true"></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="3">
              <v-text-field v-model="search" append-icon="search" v-bind:label="$t('common.search')" single-line
                            hide-details outlined :dense="true"></v-text-field>
            </v-col>
          </v-row>
          <!-- </v-container> -->
        </v-toolbar>

      </template>

      <template v-slot:[`item.action`]="{ item }">
        <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" small class="mr-2"  @click="showEditDialog(item)">
              edit
            </v-icon>
          </template>
          <span> {{ $t('tooltip_infor.edit') }}</span>
        </v-tooltip>

        <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" small class="mr-2" @click="deleteItem(item)">
              delete
            </v-icon>

          </template>
          <span> {{ $t('tooltip_infor.delete') }}</span>
        </v-tooltip>

        <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" small @click="showDialogAssignCompetitor(item)">
              assignment
            </v-icon>

          </template>
          <span> {{ $t('target.assign_competitor') }}</span>
        </v-tooltip>

      </template>

      <template v-slot:[`item.activate`]="{ item }">
        <div class="contentAddress">
          <span>
            {{ getStringByActivate(item.activate) }}
          </span>
        </div>
      </template>

      <template v-slot:[`item.competitor`]="{ item }">
        <div class="contentAddress" v-if="item.competitor">
          <span>
                {{item.competitor.name}}
          </span>
        </div>
        <div class="contentAddress" v-else>
          <span>
                {{$t('target.none_competitor') }}
          </span>
        </div>
      </template>

      <template v-slot:[`item.orderUnit`]="{ item }">
        <div class="contentAddress">
          <span>
                {{item.orderUnit.name}}
          </span>
        </div>
      </template>

      <template v-slot:[`item.status`]="{ item }">
        <div class="contentAddress">
          <span>
            {{ getStringByStatus(item.status) }}
          </span>
        </div>
      </template>

      <template v-slot:[`item.contact`]="{ item }">
        <v-btn color="primary" dark @click="showDialogCreateContact(item)">
          {{ $t('target.create_contact') }}
        </v-btn>
      </template>

      <template v-slot:no-data>
        <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
      </template>
    </v-data-table>

    <div class="text-center pt-2">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>

    <v-dialog v-model="dialogAssignCompetitor" max-width="50%" persistent>
      <v-card class="elevation-16 mx-auto">
        <v-card-title class="headline" primary-title>
          {{ $t('target.assign_competitor') }}
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
          <div class="text-center mt-12">
            <v-autocomplete v-model="selectCompetitor" :items="competitors" item-text="name"
                            v-bind:label="$t('target.select_competitor')" return-object outlined>

            </v-autocomplete>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-space-between">
          <v-btn color="primary" width="120px" @click="closeDialogAssignCompetitor"> {{ $t('common.cancel') }}</v-btn>
          <v-btn color="primary" width="120px" @click="assignCompetitor">
            {{ $t('common.ok') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <target-dialog v-model="dialogEditTarget" :editedItem="editedItem" :type="type" :orderUnits="orderUnits" :selectOrderUnit="selectOrderUnit" @closeDialog="closeDialogTarget" @updateTarget="updateTarget"
                   v-if="editedItem">
    </target-dialog>

    <v-dialog v-model="dialogCreateContact" max-width="50%" persistent>
      <v-card class="elevation-16 mx-auto">
        <v-card-title class="headline" primary-title>
          {{ $t('target.create_contact') }}
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
          <div class="text-center mt-12">
            <v-text-field v-model="contactName" :rules="stringRules" v-bind:label="$t('target.contact_name')" outlined>
            </v-text-field>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-space-between">
          <v-btn color="primary" width="120px" @click="closeDialogCreateContact"> {{ $t('common.cancel') }}</v-btn>
          <v-btn color="primary" width="120px" @click="createContact">
            {{ $t('common.ok') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>


  </v-container>
</template>

<script>
import i18n from '@/plugins/i18n';
import TargetDialog from "@/components/TargetDialog";

export default {
  data: () => ({
    overlay: false,
    isSearching: false,

    show: false,
    e1: 0,
    page: 1,
    type: 0,
    pageCount: 0,
    itemsPerPage: 10,
    isEdit: false,

    loading: true,
    numberPage: [
      5, 10, 15, 20, 25
    ],

    options: [
      {title: i18n.t('common.all'), value: -1},
      {title: i18n.t('common.owner_option'), value: 1}
    ],

    selectOption: {title: i18n.t('common.all'), value: -1},

    modal: false,

    dialogEditTarget: false,
    dialogCreateContact: false,

    firstEdit: true,
    search: '',
    dialog: false,

    headers: [
      {text: '#', align: 'left', sortable: false, value: 'index'},
      {text: i18n.t('target.name'), value: 'name'},
      {text: i18n.t('target.order_unit'), value: 'orderUnit'},
      {text: '', sortable: false, value: 'orderUnit.name', align: ' d-none'},

      {text: i18n.t('target.competitor'), value: 'competitor'},
      {text: '', sortable: false, value: 'competitor.name', align: ' d-none'},

      {text: i18n.t('target.activate'), value: 'activate'},

      {text: i18n.t('target.status'), value: 'status'},

      {text: '', value: 'contact', sortable: false},
      {text: '', value: 'action', sortable: false}
    ],

    desserts: [],
    originalDesserts: [],

    editedIndex: -1,
    editedItem: null,
    defaultItem: {},

    selectDepartment: null,
    departments: [],

    selectTeam: null,
    teams: [],

    selectStaff: null,
    staffs: [],

    provinces: [],
    selectProvince: {},

    selectDistrict: null,
    districts: [],

    selectOrderUnit: {},
    orderUnits: [],

    dialogAssignCompetitor: false,
    selectCompetitor: {},
    competitors: [],

    contactName: '',
    stringRules: [
      v => !!v || i18n.t('validate.not_empty'),
      //   v => (v && v.length > 3) || i18n.t('validate.string_invalid')
    ],
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? i18n.t('staff_management.add_management') : i18n.t('staff_management.edit_management')
    },

    computedDateFormatted() {
      return this.formatDate(this.date)
    },
  },

  components: {
    TargetDialog: TargetDialog
  },

  watch: {
    selectProvince(val) {
      if (val) {
        this.getDistrictByProvinceID(val.province_id);
      }
    },
    //
    selectDistrict(val) {
      if (val) {
        this.getOrderUnitByDistrict(val._id);
      }
    },

    selectOrderUnit(val) {
      if (val) {
        this.filterData();
      }
    },

    selectOption(val) {
      if (val) {
        this.filterData();
      }
    }
  },

  async created() {
    await this.getProvince();
    await this.getData();
    await this.getCompetitors();

    this.isSearching = true;
  },

  async mounted() {

  },

  methods: {
    initialize() {
    },

    filterData() {
      if (!this.originalDesserts || this.originalDesserts.length == 0) {
        return;
      }

      const self = this;

      if (this.selectProvince) {
        this.desserts = [].concat(this.originalDesserts.filter(item => self.selectProvince._id === item.orderUnit.vtProvince._id));
      }

      if (self.selectDistrict._id !== "-1") {
        self.desserts = [].concat(self.desserts.filter(function(item) {

          if (item.orderUnit.vtDistrict) {
            return item.orderUnit.vtDistrict._id === self.selectDistrict._id;
          }
        }));
      }

      if (self.selectOrderUnit._id !== "-1") {
        self.desserts = [].concat(self.desserts.filter(function(item) {
          if (item.orderUnit) {
            return item.orderUnit._id === self.selectOrderUnit.v;
          }
        }));
      }

      if (!this.$isAdmin && this.selectOption.value !== -1) {
        this.desserts = [].concat(this.desserts.filter(item => this.$getUserID === item.createdBy._id));
      }

      this.desserts.forEach((item, index) => item.index = index + 1);
      this.totalItems = this.desserts.length;
    },

    async getData() {
      this.overlay = this.isSearching;
      try {
        this.originalDesserts = await this.$getAllTargets();

        this.overlay = false;
        this.loading = false;

        this.filterData();
        // if (this.$isAdmin) {
        //   this.desserts = await this.$getAllTargets();
        // } else {
        //   if (this.$getUserCategory === 1) {
        //     this.desserts = await this.$getTargetOfMine();
        //   } else {
        //     this.desserts = await this.$getTargetInContext();
        //   }
        // }
      } catch (e) {
        console.log(e.stack);
      }
    },

    showDialogCreateContact(item) {
      this.dialogCreateContact = true;
      this.editedItem = item;
      this.editedIndex = this.desserts.indexOf(item);
    },

    closeDialogCreateContact() {
      this.dialogCreateContact = false;
      this.editedItem = null;
      this.editedIndex = -1;
    },

    async createContact() {
      const requestBody = {
        name: this.contactName,
        sale: this.$getUserID,
        target: this.editedItem
      }
      const response = await this.$http.post('contact/', requestBody);
      if (response.data && response.data.success) {
        this.$fire({
          title: i18n.t('common.success'),
          text: "",
          type: "success"
        }).then(() => {
          this.closeDialogCreateContact();
        });
      }
    },

    getStringByStatus(value) {
      if (value == 0) {
        return i18n.t('target.not_occupied')
      } else if (value == 1) {
        return i18n.t('target.occupied')
      } else {
        return i18n.t('target.captured')
      }
    },

    getStringByActivate(value) {
      if (value == 0) {
        return i18n.t('target.unapproved')
      } else if (value == 1) {
        return i18n.t('target.approved')
      }
    },

    showCreateTargetDialog() {
      this.type = 2;
      this.dialogEditTarget = true;
      this.editedItem = {}
    },

    showEditDialog(item) {
      this.type = 1;
      this.dialogEditTarget = true;
      this.editedItem = item;
      this.editedIndex = this.desserts.indexOf(item)
    },

    closeDialogTarget(value) {
      this.dialogEditTarget = value;
      this.editedItem = null;
      this.editedIndex = -1;
    },

    async deleteItem(item) {
      const agree = confirm(i18n.t('common.confirm_delete'))

      if (agree) {
        const response = await this.$http.delete('/target/' + item._id);
        if(response.data && response.data.success) {
          this.desserts.splice(item.index - 1, 1);
          this.desserts.forEach((item, index) =>item.index = index + 1);
        } else if(response.data && !response.data.success) {
          alert(i18n.t(response.data.message));
        } else {
          alert(i18n.t('validate.request_error'));
        }
      }
    },

    updateTarget(value) {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], value);
      } else {
        this.getData();
      }
    },

    closeDialogAssignCompetitor() {
      this.dialogAssignCompetitor = false;
      this.editedItem = null;
      this.editedIndex = -1;
    },

    showDialogAssignCompetitor(item) {
      this.dialogAssignCompetitor = true;
      this.editedItem = item;
      this.editedIndex = this.desserts.indexOf(item)
    },

    async assignCompetitor() {
      this.editedItem.competitor = this.selectCompetitor;

      const response = await this.$http.put('target/' + this.editedItem._id, this.editedItem);
      if (response.data && response.data.success) {
        this.$fire({
          title: i18n.t('common.update_success'),
          text: "",
          type: "success"
        }).then(() => {
          if (this.editedIndex > -1) {
            this.editedItem.status = 2;
            Object.assign(this.desserts[this.editedIndex], this.editedItem);
          }

          this.closeDialogAssignCompetitor();
        });
      }
    },

    async getOrderUnitByDistrict(districtId) {
      let contextArr;
      if (districtId === "-1") {
        contextArr = await this.$getAllOrderUnitByProvince(this.selectProvince._id);
      } else {
        contextArr = await this.$getAllOrderUnitByDistrict(districtId);
      }

      const optionAll = {
        name : "Tất cả",
        _id : "-1"
      }

      this.selectOrderUnit = optionAll;
      this.orderUnits = [optionAll].concat(contextArr);
    },

    // filterStaff(team) {
    //   if (!this.fullStaff || this.fullStaff.length == 0) {
    //     return;
    //   }
    //
    //   this.staffs = [].concat(this.fullStaff);
    //
    //   let tempDataArray = [];
    //   if (this.selectTeam && this.selectTeam._id != -1) {
    //     this.staffs.forEach(item => {
    //       const job = item.job;
    //       if (job.context) {
    //         if (job.context._id === team._id) {
    //           tempDataArray.push(item);
    //         }
    //       }
    //     })
    //
    //     this.staffs = [].concat(tempDataArray);
    //     if (this.staffs.length > 0 && !this.selectStaff) {
    //       this.selectStaff = this.staffs[0];
    //     }
    //   }
    // },

    // async getProvince() {
    //   if (this.$isAdmin) {
    //     this.provinces = await this.$getAllProvinces();
    //
    //   } else {
    //     if (this.$getUserCategory === 3 ) {
    //       this.provinces = await this.$getProvincesByContext(this.$getUserContextID);
    //       if (this.provinces.length > 0) {
    //         this.selectProvince = this.provinces[0];
    //       }
    //     } else if (this.$getUserCategory === 2 ) {
    //       const data = await this.$getDetailContext(this.$getUserContextID);
    //       const contextDepartment = data.parents[1];
    //
    //       this.provinces = await this.$getProvincesByContext(contextDepartment._id);
    //     }
    //   }
    //
    //   if (this.provinces.length > 0) {
    //     this.selectProvince = this.provinces[0];
    //   }
    // },

    // async getDistrictByProvinceID(provinceId) {
    //   if (this.$isAdmin || this.$getUserCategory === 3) {
    //     this.districts = await this.$getDistrictByProvince(provinceId);
    //     if (this.districts.length > 0) {
    //       this.selectDistrict = this.districts[0];
    //     }
    //   } else {
    //     this.districts = await this.$getDistrictByContext(this.$getUserContextID, this.selectProvince.province_id);
    //
    //     if (this.districts.length > 0) {
    //       this.selectDistrict = this.districts[0];
    //     }
    //   }
    // },

    async getProvince() {
      this.provinces = await this.$getAllProvinces();
      this.selectProvince = this.provinces[0];
    },

    async getDistrictByProvinceID(provinceId) {
      const contextArr = await this.$getDistrictByProvince(provinceId);
      const optionAll = {
        district_name : "Tất cả",
        _id : "-1"
      }

      this.selectDistrict = optionAll;
      this.districts = [optionAll].concat(contextArr);
    },

    async getCompetitors() {
      try {
        const response = await this.$http.get(process.env.VUE_APP_COMPETITOR_API);
        if (response.data && response.data.success) {
          const contextArr = response.data.data;
          this.competitors = contextArr;
          if (this.competitors.length > 0) {
            this.selectCompetitor = this.competitors[0];
          }
        }
      } catch (e) {
        console.log(e.stack);
      }
    }
  },
}
</script>

<style scoped>

.v-text-field .v-input__control .v-input__slot {
  min-height: 45px !important;
  /* display: flex !important; */
  align-items: center !important;
}
</style>
